import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BackUrlParams } from '../models/back-url-params.model';
import { Router } from '@angular/router';
import { CHECKOUT_STEPS_ROUTE, FeatureToggleEnum, ORDER_LINK, ORDER_STEP_ADDRESS, ORDER_STEP_THANKYOU } from '~shared/constants';
import { APP_BASE_HREF } from '@angular/common';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StepperService {
  private selectStepSource = new Subject<string>();
  private previousStepSource = new Subject<string>();
  private nextStepSource = new Subject<string>();
  private backUrlParams: BackUrlParams;

  selectStepSource$ = this.selectStepSource.asObservable();
  previousStep$ = this.previousStepSource.asObservable();
  nextStep$ = this.nextStepSource.asObservable();

  constructor(
    private router: Router,
    private readonly featureFlagService: ActiveFeaturesConfigcatService,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {}

  getBackUrlParams() {
    return this.backUrlParams;
  }

  setBackUrlParams(backUrl: BackUrlParams) {
    this.backUrlParams = backUrl;
  }

  nextStep() {
    this.nextStepSource.next();
  }

  prevStep() {
    this.previousStepSource.next();
  }

  goToStep(stepIndex) {
    this.selectStepSource.next(stepIndex);
  }

  goToThankYouPage() {
    this.router.navigate([ORDER_LINK, ORDER_STEP_THANKYOU]);
  }

  goToAddressStep() {
    return this.featureFlagService
      .isFeatureEnabledReadyForCurrentCountry$(FeatureToggleEnum.FF_EXTERNAL_CHECKOUT_ADDRESS_STEP)
      .pipe(
        tap(isEnabled => {
          if (isEnabled) {
            const location = `/${this.baseHref.replace(new RegExp('/', 'g'), '')}/${CHECKOUT_STEPS_ROUTE}/${ORDER_STEP_ADDRESS}`;
            window.location.href = location;
            return;
          }

          this.router.navigate([ORDER_LINK, ORDER_STEP_ADDRESS]);
        })
      );


  }
}
